import React from "react";
import Logo from "@assets/Logo";
import { useTranslation } from "react-i18next";

const IntelliFallback = () => {
  const { t } = useTranslation();
  return (
    <div
      className="w-100 d-flex flex-column justify-content-center align-items-center position-absolute"
      style={{
        height: "100dvh",
        backgroundColor: "#fff",
        zIndex: "9999",
        top: "0",
        left: "0",
      }}
    >
      <div
        style={{ position: "absolute", top: "25%" }}
        className="d-flex flex-column justify-content-center align-items-center"
      >
        <h1 style={{ fontSize: "1.8rem" }}>{`¡${t(
          "WizardEnroll.welcome"
        )}!`}</h1>
        <Logo />
      </div>
      <div className="loading">
        <div className="effect-1 effects"></div>
        <div className="effect-2 effects"></div>
        <div className="effect-3 effects"></div>
      </div>
      <span style={{ position: "absolute", bottom: "5%" }}>
        Copyright © {new Date().getFullYear()} Intelli Next Corp.
      </span>
    </div>
  );
};

export default IntelliFallback;
